import axios from 'axios';

// Production: '/api' (relative, aynı sunucu)
// Development: REACT_APP_SERVER_URL tanımlıysa onu kullan (örn: https://bayi.vegamat.com)
//              tanımlı değilse local server'a düş (http://localhost:5000)
const SERVER_URL = process.env.NODE_ENV === 'production'
    ? ''
    : (process.env.REACT_APP_SERVER_URL || 'http://localhost:5000');

const BASE_URL = `${SERVER_URL}/api`;

// Resimler için URL
export const FILE_URL = `${SERVER_URL}/uploads`;

const instance = axios.create({
    baseURL: BASE_URL
});

// Her isteğe otomatik olarak Token ekle (Eğer giriş yapılmışsa)
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;
